var Base = require('_js/base'),
  ko = require('knockout');

var model = function(params) {
  this.params = params;
};

function MyCoursesPage() {
  this.init();
}

MyCoursesPage.prototype = new Base();

MyCoursesPage.prototype.init = function() {
  var $myCoursesPage = $('[data-my-courses-page]');
  if ($myCoursesPage.get(0) !== undefined) {
    ko.applyBindings(
      new model({ element: $myCoursesPage.data('my-courses-page') }),
      $myCoursesPage.get(0)
    );
  }
};

module.exports = MyCoursesPage;
